// extracted by mini-css-extract-plugin
module.exports = {"menu":"featured_menu__UZKV9","focus-visible":"featured_focus-visible__4Ikri"};